import React from 'react';
import {useParams} from 'react-router-dom';
import {Breadcrumb, Breadcrumbs} from '~/components/Breadcrumps';
import {ResourceLoader, useResource} from '~/lib/loader';
import {biddersLinks} from '~/modules/Bidders';
import {
    fetchBidder,
    fetchPreTargetingConfig,
    fetchPreTargetingRules,
    fetchPreTargetingSchema,
    fetchPreTargetingVariables
} from '~/modules/Bidders/api';
import {PreTargetingWizard} from '~/modules/Bidders/components/PreTargetingWizard';

interface IPreTargetingWizardViewParams {
    bidderId: string;
    preTargetingConfigId: string;
}

export const PreTargetingWizardView = () => {
    const params = useParams<IPreTargetingWizardViewParams>();
    const bidderResult = useResource(() => fetchBidder(params.bidderId));
    const configResult = useResource(() => fetchPreTargetingConfig(params.preTargetingConfigId));
    const variablesResult = useResource(() => fetchPreTargetingVariables(params.preTargetingConfigId));
    const schemaResult = useResource(() => fetchPreTargetingSchema());
    const rulesResult = useResource(() => fetchPreTargetingRules(params.preTargetingConfigId));
    return <ResourceLoader result={bidderResult} message='Loading bidder'>
        {({resource: bidder, isPending: isBidderPending}) =>
            <ResourceLoader result={configResult} message='Loading config'>
                {({resource: config, isPending: isConfigPending}) =>
                    <ResourceLoader result={variablesResult} message='Loading variables'>
                        {({resource: variables, isPending: isVariablesPending}) =>
                            <ResourceLoader result={schemaResult} message='Loading schema'>
                                {({resource: schemaInfo, isPending: isSchemaPending}) =>
                                    <ResourceLoader result={rulesResult} message='Loading rules'>
                                        {({resource: rules, isPending: isRulesPending}) =>
                                            <Breadcrumb breadcrumb={{
                                                to: biddersLinks.bidder(bidder.id),
                                                title: bidder.title
                                            }}>
                                                <Breadcrumb breadcrumb={{
                                                    to: biddersLinks.bidderPreTargetingConfig(bidder.id, config.id),
                                                    title: config.title
                                                }}>
                                                    <Breadcrumb breadcrumb={{
                                                        title: 'Wizard'
                                                    }}>
                                                        <Breadcrumbs/>
                                                        <PreTargetingWizard preTargetingConfig={config}
                                                            variables={variables}
                                                            schemaInfo={schemaInfo}
                                                            rules={rules}
                                                            onSubmit={() => {
                                                            }}
                                                            onDelete={() => {
                                                            }}/>
                                                    </Breadcrumb>
                                                </Breadcrumb>
                                            </Breadcrumb>}
                                    </ResourceLoader>}
                            </ResourceLoader>}
                    </ResourceLoader>}
            </ResourceLoader>}
    </ResourceLoader>;
};
